<template>
  <v-card class="employee-card">
    <h2>Update Pickup Date</h2>
    <div class="employee-list-block">
      <div class="alert-container">
        <span><i class="fas fa-info-circle"></i> Please select the date in <strong>DD-MM-YYYY</strong> format and time in <strong>HH:mm</strong> (24-hour) format.</span>
      </div>
      <div v-if="tripDetails.serviceType === 1">
        <div class="employee-list" v-for="(employee, index) in tripDetails.employees" :key="index">
          <!-- {{ checkDisabledTime(tripDetails.reportingTime, employee.selectedTime) }} -->
          <span>{{ employee.name }}</span>

          <div class="date-picker-container">
            <date-picker
              :value="employee.selectedDate"
              value-type="format"
              format="DD-MM-YYYY"
              placeholder="DD-MM-YYYY"
              type="date"
              @input="(val) => updateField(employee, 'selectedDate', val)"
              :disabled-date="checkDisabledDate"
              :clearable="false"
            />
            <date-picker
              v-model="employee.selectedTime"
              format="HH:mm"
              placeholder="HH:MM"
              value-type="format"
              type="time"
              @input="(val) => updateField(employee, 'selectedTime', val)"
              :default-value="employee.selectedTime"
              :disabled-time="checkDisabledTime"
              :clearable="false"
            />
          </div>
          <!-- :default-value="employee.selectedDate" -->
        </div>
      </div>
      <div v-else>
        <div class="employee-list">
          <span>Pickup Time</span>
          <date-picker v-model="selectedDate" value-type="format" format="DD-MM-YYYY" placeholder="DD-MM-YYYY" type="date" :clearable="false" />
          <date-picker v-model="selectedTime" format="HH:mm" placeholder="HH:MM" value-type="format" type="time" :clearable="false" />
        </div>
      </div>
    </div>
    <div class="card-button-blk">
      <v-btn color="#f4c736" @click="cancelSubmit" small>Cancel</v-btn>
      <v-btn color="#eea004" @click="submit" small>Submit</v-btn>
    </div>
  </v-card>
</template>

<script>
import DatePicker from "vue2-datepicker";
import "vue2-datepicker/index.css";
import moment from "moment";
import axios from "@/axios/axios-global";

export default {
  name: "PickUpTimeUpdate",
  components: { DatePicker },
  data() {
    return {
      selectedDate: "",
      selectedTime: "",

      // time1: null,
      // time2: null,

      employees: [],

      //    tripList: [],
      selectedDate: null,
      selectedTime: null,
    };
  },
  props: {
    tripDetails: Object,
    driverDetails: Object,
    vehicleData: Object,
  },
  //  watch: {
  //   tripDetails() {
  //    this.tripDetails.employees.map((employee) => {
  //     employee["selectedDate"] = moment(employee.pickupdate, "DD-MM-YYYY hh:mm A").format("DD-MM-YYYY");
  //     console.log(employee.selectedDate);
  //    });
  //   },
  //  },
  created() {
    this.tripDetails.employees.forEach((employee) => {
      const defaultDate = employee.pickupdate || moment().format("DD-MM-YYYY hh:mm A");
      const employeeDate = moment(defaultDate, "DD-MM-YYYY hh:mm A");
      this.$set(employee, "selectedDate", employeeDate.format("DD-MM-YYYY"));
      this.$set(employee, "selectedTime", "");
    });
    this.selectedDate = this.tripDetails.pickUpTime ? moment(this.tripDetails.pickUpTime, "x").format("DD-MM-YYYY") : "";
    this.selectedTime = "";
  },
  computed: {
    formattedDates() {
      return this.tripDetails.employees.map((employee) => moment(employee.pickupdate ? employee.pickupdate : moment().format("DD-MM-YYYY hh:mm A"), "DD-MM-YYYY hh:mm A").format("YYYY-MM-DD"));
    },
    formattedTimes() {
      return this.tripDetails.employees.map((employee) =>
        moment(employee.pickupdate ? employee.pickupdate : moment().format("DD-MM-YYYY hh:mm A"), "DD-MM-YYYY hh:mm A", "DD-MM-YYYY hh:mm A").format("HH:mm")
      );
    },
  },
  methods: {
    //   updatePickUpDate(newDate, index) {
    //    this.selectedDate = moment(newDate, "YYYY-MM-DD").format("DD-MM-YYYY");
    //   },
    //   updatePickUpTime(newTime, index) {
    //    console.log(newTime);
    //    const currentDate = moment(this.tripDetails.employees[index].pickupdate, "DD-MM-YYYY hh:mm A").format("DD-MM-YYYY");
    //    this.selectedTime = moment(`${currentDate} ${newTime}`, "DD-MM-YYYY HH:mm").format("hh:mm A");
    //   },

    //   confirm(data, index) {
    //    this.$set(data, "dateMenu", false);
    //    if (!this.selectedDate) this.selectedDate = moment(data.pickupdate, "DD-MM-YYYY hh:mm A").format("DD-MM-YYYY");
    //    const dateTime = moment(`${this.selectedDate} ${this.selectedTime ? this.selectedTime : moment(data.pickupdate, "DD-MM-YYYY hh:mm A").format("hh:mm A")}`, "DD-MM-YYYY hh:mm A").format(
    //     "DD-MM-YYYY hh:mm A"
    //    );
    //    this.$set(data, "changedDate", dateTime);

    //    //  let employees = []

    //    //  this.$set(this.tripDetails, "employees", employees);
    //   },

    updateField(employee, field, value) {
      this.$set(employee, field, value);
      if (field === "selectedDate") this.selectedDate = value;
    },

    submit() {
      let changedDate = "";
      let employeeIds = [];
      if (this.tripDetails.employees.every((employee) => employee.selectedTime) || this.selectedTime) {
        // if (this.tripDetails.serviceType === 1) {
        //   this.employees = this.tripDetails.employees.map((employee) => {
        //     employee["changedDate"] = moment(`${employee.selectedDate} ${employee.selectedTime}`, "DD-MM-YYYY HH:mm").format("DD-MM-YYYY hh:mm A");
        //     const date1 = moment(employee.pickupdate, "DD-MM-YYYY hh:mm A").format("DD-MM-YYYY hh:mm A");
        //     const date2 = moment(employee.changedDate, "DD-MM-YYYY hh:mm A").format("DD-MM-YYYY hh:mm A");
        //     return {
        //       id: employee.id,
        //       pickupTime: moment(employee.changedDate ? employee.changedDate : employee.pickupdate, "DD-MM-YYYY hh:mm A").valueOf(),
        //       isChanged: date1 === date2 || !employee.changedDate ? false : true,
        //     };
        //   });
        // } else {
        //   this.employees = [];
        //   changedDate = moment(`${this.selectedDate} ${this.selectedTime}`, "DD-MM-YYYY HH:mm").valueOf();
        // }
        if (this.tripDetails.serviceType === 1) {
          employeeIds = this.tripDetails.employees.map(e => e.crewId);
          this.employees = this.tripDetails.employees.map((employee) => {
            employee["changedDate"] = moment(`${employee.selectedDate} ${employee.selectedTime}`, "DD-MM-YYYY HH:mm").format("DD-MM-YYYY hh:mm A");
            const date1 = moment(employee.pickupdate, "DD-MM-YYYY hh:mm A").format("DD-MM-YYYY hh:mm A");
            const date2 = moment(employee.changedDate, "DD-MM-YYYY hh:mm A").format("DD-MM-YYYY hh:mm A");
            return {
              id: employee.id,
              pickupTime: moment(employee.changedDate ? employee.changedDate : employee.pickupdate, "DD-MM-YYYY hh:mm A").valueOf(),
              isChanged: date1 === date2 || !employee.changedDate ? false : true,
            };
          });
        } else {
          employeeIds = this.tripDetails.employees.map(e => e.crewId);
          this.employees = [];
          changedDate = moment(`${this.selectedDate} ${this.selectedTime}`, "DD-MM-YYYY HH:mm").valueOf();
        }
        this.$emit("submit", { employees: this.employees, pickUpdate: changedDate, crewIds: employeeIds.length > 0 ? employeeIds : [] });
      } else {
        this.$toasted.show("Please select time", {
          position: "bottom-center",
          duration: 5000,
        });
      }

      // this.$emit("submit", employees);
    },
    cancelSubmit() {
      this.tripDetails.employees.forEach((employee) => {
        if (employee.hasOwnProperty("changedDate")) {
          this.$delete(employee, "changedDate");
        }
      });
      this.$emit("cancelSubmit");
    },
    cancelCalendar(data, index) {
      this.$set(data, "dateMenu", false);
    },
    convertDate(date) {
      return moment(date, "DD-MM-YYYY hh:mm A").format("YYYY-MM-DD");
    },
    convertTime(date) {
      const date1 = moment(date, "DD-MM-YYYY hh:mm A");
      const date2 = moment(this.selectedDate, "DD-MM-YYYY");
      if (this.selectedDate && !date1.isSame(date2, "date")) {
        return "";
      } else {
        return moment(date, "DD-MM-YYYY hh:mm A").format("HH:mm");
      }
    },

    //     checkDisabledTime(pickupdate) {
    //   //    const employeeDetails = this.tripDetails.employees.find((employee) => employee.selectedTime === moment(pickupdate).format("HH:mm"));
    //   const reportingTime = moment(this.tripDetails.reportingTime).subtract(10, "minutes").format("HH:mm");
    //   const pickupdateTime = moment(pickupdate).format("HH:mm");
    //   //    if (employeeDetails && employeeDetails.selectedDate !== moment(this.tripDetails.reportingTime).subtract(20, "minutes").format("DD-MM-YYYY")) {
    //   //     return true;
    //   //    } else {
    //   return pickupdateTime > reportingTime;
    //   //    }
    // },

    checkDisabledTime(pickedTime) {
      const reportingDate = moment(this.tripDetails.reportingTime).subtract(20, "minutes").format("DD-MM-YYYY");
      const reportingTime = moment(this.tripDetails.reportingTime).subtract(20, "minutes").format("HH:mm");
      const pickupdateTime = moment(pickedTime).format("HH:mm");
      // Selected date (from employee)
      // const selectedDate = moment(this.selectedDate, "DD-MM-YYYY").format("DD-MM-YYYY");
      // const reportingDate = moment(reporting).format("DD-MM-YYYY");

      if (this.selectedDate === reportingDate) {
        return pickupdateTime > reportingTime;
      } else {
        return false;
      }

      // // ✅ If selected date is NOT the reporting date → allow all times
      // if (!selectedDate.isSame(reportingDate, "day")) {
      //   // console.log(reportingDate,"reportingDate");
      //   return false; // ❌ do NOT disable any time
      // }
      // console.log(selectedDate.isSame(reportingDate, "day"), "sssssssssssssssssssssssssssssssssssssssssssssssssssssssssssssssssss");

      // if (selectedDate.isSame(reportingDate, "day")) {
      //   return selectedTime > reporting;
      // }

      // ✅ If selected date is SAME as reporting date
      // disable times after reporting time
      // return selectedTime.isAfter(reporting);
    },

    // checkDisabledTime(pickedTime) {
    //   const reporting = moment(this.tripDetails.reportingTime, "DD-MM-YYYY HH:mm");

    //   // Selected date (from employee)
    //   const selectedDate = moment(this.selectedDate, "DD-MM-YYYY");
    //   const reportingDate = moment(this.tripDetails.reportingTime);
    //   console.log(selectedDate,reportingDate,"reportingDate")

    //   const selectedTime = moment(pickedTime, "HH:mm");

    //   // ✅ If selected date is NOT the reporting date → allow all times
    //   if (!selectedDate.isSame(reportingDate, "day")) {
    //     return false; // ❌ do NOT disable any time
    //   }

    //   // ✅ If selected date is SAME as reporting date
    //   // disable times after reporting time
    //   return selectedTime.isAfter(reporting);
    // },

    checkDisabledDate(pickupdate) {
      const reportingTime = moment(this.tripDetails.reportingTime).subtract(20, "minutes");
      const pickupdateTime = moment(pickupdate);
      return pickupdateTime > reportingTime;
    },
    //   clubTrip(data) {
    //     this.$emit("club-trip",data);
    //   }
  },
};
</script>
+

<style lang="scss" scoped>
.employee-card {
  padding: 10px;
  border-radius: 0;
  h2 {
    text-align: center;
    border-bottom: 1px solid #d5d5d5;
    font-weight: bold;
  }
  .employee-list-block {
    padding: 10px 0;
    display: flex;
    flex-direction: column;
    gap: 10px;

    .alert-container {
      font-size: 12px;
      background: #c8f2ff;
      padding: 5px;
    }
    .employee-list {
      display: flex;
      justify-content: space-between;
      align-items: center;
      border-bottom: 1px solid #fddddd;
      padding: 10px;

      .date-picker-container {
        display: flex;
        gap: 10px;
      }
      //    .fas {
      //     color: #e70101;
      //     font-size: 13px;
      //     margin-left: 10px;
      //     cursor: pointer;
      //    }
    }
  }
  .card-button-blk {
    display: flex;
    justify-content: center;
    align-items: center;
    gap: 15px;
    padding: 10px;
    border-top: 1px solid #ebebeb;
  }
}

.v-date-time-widget-container .flex {
  display: flex;
  flex-direction: column;
  padding: 0 5px;
  justify-content: space-between;
}

.v-date-time-widget-container .flex.text-xs-center {
  flex-direction: row;
  justify-content: flex-end;
  padding: 0;
}

.v-date-time-widget-container {
  background: white;
  padding: 15px;
}

.v-date-time-widget-container {
  background: white;
  padding: 15px;
}

.row {
  margin-top: 0;
}
.v-date-time-widget-container h3 {
  font-weight: 800;
  font-size: 1.1rem;
  //  color: #db670f;
  text-align: center;
  padding: 5px 0;
}
.calendar-footer {
  padding: 5px !important;
}
.v-date-time-widget-container .calendar-footer .v-btn {
  margin-left: 10px;
}
</style>
